import axios from "axios";
import { config, config_multipart } from "../../api-helper/api-header-configs";
const baseURL = process.env.REACT_APP_API_URL;

// Create Platform
export const create_platform = async (values: any) => {
    // Check if values is FormData (has files) or regular object
    const isFormData = values instanceof FormData;
    const requestConfig = isFormData ? config_multipart : config;
    
    const response = await axios.post(baseURL + "/platforms", values, requestConfig);
    return response.data;
}

// List All Platforms
export const get_all_platforms = async () => {
    const response = await axios.get(baseURL + "/platforms", {
        params: {
            _t: Date.now() // Cache busting
        }
    });
    return response.data;
}

// Get Single Platform
export const get_platform_by_id = async (id: string) => {
    const response = await axios.get(baseURL + `/platforms/${id}`, config);
    return response.data;
}

// Update Platform
export const update_platform = async (id: string, values: any) => {
    // Check if values is FormData (has files) or regular object
    const isFormData = values instanceof FormData;
    const requestConfig = isFormData ? config_multipart : config;
    
    const response = await axios.post(baseURL + `/platform-update/${id}`, values, requestConfig);
    return response.data;
}

// Delete Platform
export const delete_platform = async (id: string) => {
    const response = await axios.delete(baseURL + `/platforms/${id}`, config);
    return response.data;
}

